import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class PostDataService {
	instituteData = {
		instituteName: '',
		instituteCity: '',
		instituteState: '',
		institutePin: '',
		instituteEmail: '',
		chequeNumber: '',
		chequeImgUrl: '',
		students: []
	};

	student = {
		firstName: '',
		lastName: '',
		email: null,
		entryCategory: '',
		entrySubCategory: '',
		standard: -1,
		language: null,
		pincode: '',
		instituteName: '',
		instituteState: '',
		hasParticipated: false,
		details: null
	};

	resetStudent = {
		firstName: '',
		lastName: '',
		email: null,
		entryCategory: '',
		entrySubCategory: '',
		standard: -1,
		language: null,
		pincode: '',
		instituteName: '',
		instituteState: '',
		hasParticipated: false,
		details: null
	};

	resetInstitute = {
		instituteName: '',
		instituteCity: '',
		instituteState: '',
		institutePin: '',
		instituteEmail: '',
		chequeNumber: '',
		chequeImgUrl: '',
		students: []
	};

	EditModeSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	editStudentDetails: any;

	constructor() {
	}
}
